import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import { isAdminProfile } from '../utils/firebase/auth.utils'

const RequireAuth = ({ allowedRoles = ['admin'] }) => {
    const { currentUser, authReady } = useAuth();
    const location = useLocation();

    if (!authReady) {
        return (
            <div className="flex min-h-[40vh] items-center justify-center text-sm text-gray-600">
                Checking access…
            </div>
        );
    }

    const isAdmin = isAdminProfile(currentUser);
    const roleOk = isAdmin && (
      !allowedRoles?.length || allowedRoles.includes(currentUser.status)
    );

    if (roleOk) {
        return <Outlet />;
    }

    return <Navigate to="/login" state={{ from: location }} replace />;
}

export default RequireAuth;
